import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-twitter\"><path class=\"cls-1\" d=\"M768.718,109.868h138.289l-299.004,343.855,351.33,463.456h-276.579l-216.778-284.054-246.678,284.054H81.009l321.429-366.28L62.321,109.868h284.054l194.353,257.891,227.991-257.891ZM720.13,834.953h74.751L305.262,184.619h-82.226l497.094,650.334Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol